import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { LoginService } from '../../../core/services/login.service';
import { SessionStorageService } from '../../../core/services/session-storage.service';
import { MaintenanceWindowNotice } from '../../models/maintenanceWindowNotice';
import { LoginChallengeDataService } from '../../../core/services/login-challenge-data.service';
import { LoginPageApiService } from '../../../core/services/login-page-api.service';
import { GtCalendarTimePipe } from '../../../core/pipes/gt-calendar-time.pipe';
import { NgIf } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'maintainance-notice',
    templateUrl: 'maintenance-notice.component.html',
    styleUrls: ['maintenance-notice.component.scss'],
    imports: [NgIf, GtCalendarTimePipe]
})
export class MaintenanceNoticeComponent implements OnInit {
  public loginChallenge: string;
  public notes: any;
  public disableGreytHrLogo = false;
  private destroyRef = inject(DestroyRef);
  constructor(private _sessionStorage: SessionStorageService,
    private _loginService: LoginService,
    private _loginChallengeDataService: LoginChallengeDataService,
    private _loginPageApiService: LoginPageApiService,
  ) {}

  public ngOnInit() {
    this.loginChallenge = this._loginChallengeDataService.getLoginChallenge();
    this._loginService.getMaintenanceWindowNotes(this.loginChallenge, 'underway')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: MaintenanceWindowNotice) => {
        const {windows} = res;
        [this.notes] = windows;
      });
    this._loginPageApiService.getLoginPage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.disableGreytHrLogo = res['disableGreytHrLogo'] || false;
      });
  }
}
